
import styled from 'styled-components';

export const CoursesWrapper = styled.div`
   display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;